import { useCallback, useState } from 'react';
import { useNotifications } from 'hooks/useNotifications';
import { useDeleteCrmActivity } from 'services/CrmApi/mutations/useDeleteCrmActivity';
import { ICrmActivity } from 'services/CrmApi/types/CrmActivityTypes';

export const useDeleteActivity = (activity: ICrmActivity, onDeleteSuccess: () => void) => {
  const { showSuccessNotification, showErrorNotification } = useNotifications();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteActivityMutation = useDeleteCrmActivity();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const handleOpenDeleteModal = useCallback(() => {
    setConfirmationModalOpen(true);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    if (!activity) {
      return;
    }

    try {
      setIsDeleting(true);
      await deleteActivityMutation.mutateAsync(activity.id);
      showSuccessNotification('Activity deleted successfully.');
      onDeleteSuccess();
    } catch (error) {
      showErrorNotification('Error deleting activity.');
    } finally {
      setConfirmationModalOpen(false);
      setIsDeleting(false);
    }
  }, [activity, deleteActivityMutation, onDeleteSuccess, showErrorNotification, showSuccessNotification]);

  const handleCancelDelete = useCallback(() => {
    setConfirmationModalOpen(false);
  }, []);

  return {
    isDeleting,
    confirmationModalOpen,
    handleOpenDeleteModal,
    handleConfirmDelete,
    handleCancelDelete,
  };
};
